import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalPage.css';

function TermsPage() {
  return (
    <div className="legal-page">
      <Navbar />

      <div className="legal-container">
        <div className="legal-header">
          <Link to="/" className="legal-back">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
              <path d="M19 12H5m7-7l-7 7 7 7"/>
            </svg>
            Back to Home
          </Link>
          <h1>Terms of Service</h1>
          <p className="legal-updated">Last updated: March 2026</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using Mindmark ("the Service"), you agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use the Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Description of Service</h2>
            <p>
              Mindmark is an AI-powered tool designed to assist Australian psychologists in reviewing their
              marketing and advertising content for potential compliance issues. The Service analyzes
              text, URLs, and uploaded documents against AHPRA advertising guidelines, the Psychology Board
              Code of Conduct, and mandatory notification requirements. The Service also includes
              Compliance Chat, which allows users to ask questions about regulations and receive
              answers with specific citations.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Important Disclaimers</h2>
            <div className="legal-warning">
              <h3>Not Legal or Professional Advice</h3>
              <p>
                Mindmark is an educational and assistive tool only. The Service does not provide legal,
                professional, or regulatory advice. Results from the Service should not be considered as
                definitive compliance assessments or as a substitute for professional guidance.
              </p>
            </div>
            <div className="legal-warning">
              <h3>No Guarantee of Compliance</h3>
              <p>
                Using Mindmark does not guarantee that your content complies with AHPRA regulations.
                The Service may not identify all compliance issues, and AHPRA guidelines may change.
                You remain solely responsible for ensuring your content meets all regulatory requirements.
              </p>
            </div>
            <div className="legal-warning">
              <h3>AI Limitations</h3>
              <p>
                Mindmark uses artificial intelligence which may produce inaccurate, incomplete, or
                outdated results. Always verify findings independently and consult with qualified
                professionals for definitive compliance guidance.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>4. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul>
              <li>Use the Service only for lawful purposes</li>
              <li>Not rely solely on the Service for compliance decisions</li>
              <li>Verify all results independently</li>
              <li>Keep your account credentials secure</li>
              <li>Not share your account with others</li>
              <li>Not attempt to circumvent any usage limits or security measures</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Subscription and Payments</h2>
            <p>
              Mindmark offers free and paid subscription plans (Basic and Pro). Paid subscriptions
              are billed monthly or annually through Stripe. By subscribing to a paid plan, you
              authorize us to charge your payment method on a recurring basis until you cancel.
            </p>
            <p>
              You may cancel your subscription at any time through your account settings. Cancellation
              takes effect at the end of your current billing period. We do not offer refunds for
              partial billing periods.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Intellectual Property</h2>
            <p>
              The Service, including its design, features, and content, is owned by Mindmark and
              protected by intellectual property laws. You may not copy, modify, distribute, or
              create derivative works from any part of the Service without our express written permission.
            </p>
            <p>
              You retain ownership of any content you submit to the Service for analysis. By submitting
              content, you grant us a limited license to process that content solely for the purpose
              of providing the Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Mindmark and its operators shall not be liable
              for any indirect, incidental, special, consequential, or punitive damages, including but
              not limited to:
            </p>
            <ul>
              <li>Loss of profits, revenue, or business opportunities</li>
              <li>Regulatory fines or penalties</li>
              <li>Damage to professional reputation</li>
              <li>Any consequences arising from reliance on the Service's results</li>
            </ul>
            <p>
              Our total liability for any claims arising from your use of the Service shall not exceed
              the amount you paid for the Service in the twelve months preceding the claim.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Mindmark and its operators from any claims,
              damages, losses, or expenses (including legal fees) arising from your use of the Service,
              your violation of these Terms, or your violation of any rights of a third party.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Modifications to Service and Terms</h2>
            <p>
              We reserve the right to modify, suspend, or discontinue any aspect of the Service at any
              time. We may also update these Terms from time to time. Continued use of the Service after
              changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Termination</h2>
            <p>
              We may terminate or suspend your access to the Service at our discretion, without prior
              notice, for conduct that we believe violates these Terms or is harmful to other users,
              us, or third parties.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Governing Law</h2>
            <p>
              These Terms are governed by the laws of Australia. Any disputes arising from these Terms
              or your use of the Service shall be resolved in the courts of Australia.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Contact</h2>
            <p>
              For questions about these Terms of Service, please contact us at{' '}
              <a href="mailto:support@mindmark.au">support@mindmark.au</a>
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default TermsPage;
